export default __webpack_public_path__ + "static/media/undraw_join_existing.6fdbded1.svg";